import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getFlagUrl, getPlayerName, wonSet, playerTypes, getRatingDetails, setRatingChoice } from '../../../utils';
import { titleCase } from '../../../utils/formatting';
import withAuth from '../../hocs/withAuth';
import * as actions from '../../../actions/post-score-actions';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';
import { Utr } from '../../text';
import { showMatchWinner } from '../../../utils/postScore';
import { OutComeTypes } from '../../../utils/postScoreConstants';

class DualMatchCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onSelected = this.onSelected.bind(this);
    }

    onSelected(menuOption, ev) {
        switch (menuOption.id) {
            case 'edit_score':
                this.props.setPlayerPostedMatch({
                    result: this.props,
                });
                if (this.props.match.path === '/:clubType(clubs|schools|colleges)/:clubId') {
                    const { clubId } = this.props.match.params;
                    this.props.history.push(`/clubs/${clubId}/post-score`);
                } else {
                    this.props.history.push(`/post-score-select`);
                }
                break;
            case 'resend_invites':
                this.props.resendInvites(this.props.id);
                break;
            case 'accept_score':
                this.props.acceptOrRejectScore(this.props.id, 'accept');
                break;
            case 'reject_score':
                this.props.acceptOrRejectScore(this.props.id, 'reject');
                break;
            default:
                this.props.onSelected(menuOption, ev);
                break;
        }
    }

    getMatchText(players) {
        let string = '';
        string += getPlayerName(players.winner1.firstName, players.winner1.lastName, true);
        if (players.winner2) {
            string = `${string}/${getPlayerName(players.winner2.firstName, players.winner2.lastName, true)}`;
        }
        string += ' vs ';
        string += getPlayerName(players.loser1.firstName, players.loser1.lastName, true);
        if (players.loser2) {
            string = `${string}/${getPlayerName(players.loser2.firstName, players.loser2.lastName, true)}`;
        }
        return string;
    }

    checkIfUserInMatch(auth, players) {
        if (auth && auth.user && auth.user.claimedPlayer && players) {
            const playersList = ['loser1', 'loser2', 'winner1', 'winner2'];
            let boolean = false;
            playersList.forEach((player) => {
                if (players[player] && players[player].id && parseInt(players[player].id) === auth.user.claimedPlayer.playerId) {
                    boolean = true;
                }
            });
            return boolean;
        }
        return false;
    }

    render() {
        const {
            index,
            players,
            score,
            forceCardView,
            force,
            playerId,
            gameType,
            completionType,
            outcome,
            eventDate,
            auth,
            showDecimals,
            utrType,
            showDecimalForOwn,
            isProProfile,
            ratingsNoShow,
            eventTeams,
            team1Players,
            team2Players,
            teamsDict,
            isCollegeDualMatch,
            matchObj,
            sportTypeId,
            'data-testid': dataTestId,
        } = this.props;

        let team1; let team2; const team1PlayerIds = []; const
            team2PlayerIds = [];

        const playerWithOutScore = [];
        let doubleteam1; let doubleteam2;
        if (!players && isCollegeDualMatch) {
            let team1player1; let team1player2; let team2player1; let team2player2;
            if (gameType === 'doubles') {
                doubleteam1 = matchObj?.position1 && teamsDict[matchObj?.position1.id] ? teamsDict[matchObj.position1.id] : null;
                doubleteam2 = matchObj?.position2 && teamsDict[matchObj?.position2.id] ? teamsDict[matchObj.position2.id] : null;
                if (doubleteam1) {
                    team1Players.forEach((player) => {
                        if (player.id === doubleteam1.players[0]) {
                            team1player1 = player;
                        } else if (player.id === doubleteam1.players[1]) { team1player2 = player; }
                    });
                    playerWithOutScore.push(team1player1, team1player2);
                } if (doubleteam2) {
                    team2Players.forEach((player) => {
                        if (player.id === doubleteam2.players[0]) {
                            team2player1 = player;
                        } else if (player.id === doubleteam2.players[1]) {
                            team2player2 = player;
                        }
                    });
                    playerWithOutScore.push(team2player1, team2player2);
                }
            } else if (gameType === 'singles') {
                doubleteam1 = matchObj?.position1 ? matchObj.position1.id : null;
                doubleteam2 = matchObj?.position2 ? matchObj.position2.id : null;
                team1player1 = team1Players.filter((player) => Number.parseInt(player.id) === Number.parseInt(doubleteam1));
                team2player1 = team2Players.filter((player) => Number.parseInt(player.id) === Number.parseInt(doubleteam2));
                playerWithOutScore.push(...team1player1, ...team2player1);
            }
        }
        if (!eventTeams[0].isHome) {
            ([team1, team2] = eventTeams);
        } else {
            ([team2, team1] = eventTeams);
        }
        team1Players.forEach(player => {
            team1PlayerIds.push(player.id);
        });
        team2Players.forEach(player => {
            team2PlayerIds.push(player.id);
        });

        const isHomeWinner = (winner) => {
            console.log('isHomeWinner', team2PlayerIds, winner.id, team2PlayerIds.includes(parseInt(winner.id)));
            return team2PlayerIds.includes(parseInt(winner.id));
        };

        const getPlayerTeamProfileImage = (playerId) => {
            let clubProfileImages = false;
            if (team1PlayerIds.includes(parseInt(playerId))) {
                ({ clubProfileImages } = team1);
            } else if (team2PlayerIds.includes(parseInt(playerId))) {
                ({ clubProfileImages } = team2);
            }
            console.log('getPlayerTeamProfileImage', playerId, clubProfileImages);
            return clubProfileImages;
        };

        const userLoggedIn = auth && auth.user;
        const showRatings = (userLoggedIn || isProProfile) && !ratingsNoShow;

        const walkOverValues = ['Walkover', 'Defaulted', 'Withdrew', 'Double Default', 'Abandoned', 'walkover', 'defaulted', 'withdrew', 'double default', 'abandoned'];

        const getRatingTitle = (player, gameType) => {
            const rating = getRatingDetails(setRatingChoice({ player, ratingType: gameType, utrType }));
            return rating.utrType;
        };

        const getScores = (score, playerType, scorePrefix) => {
            if (score && playerType) {
                const scoreArray = Object.values(score);
                if (scoreArray.length > 0) {
                    return (
                        <>
                            {scoreArray.map((scoreItem, i) => {
                                return (
                                    <div
                                        className={`score-item ${showMatchWinner(outcome, completionType) ? wonSet(scoreItem, playerType) ? 'winner' : '' : ''}`}
                                        key={`score-item-${i}`}
                                        data-testid={scorePrefix && `${scorePrefix}.score-${i}`}
                                    >
                                        {playerType === playerTypes.WINNER ? scoreItem.winner ? scoreItem.winner : 0 : scoreItem.loser ? scoreItem.loser : 0}
                                        {(scoreItem.tiebreak != null && !Number.isNaN(scoreItem.tiebreak)) && (
                                            <sup>{playerType === playerTypes.WINNER ? scoreItem.winnerTiebreak : scoreItem.tiebreak }</sup>
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    );
                }
                if (playerType === playerTypes.LOSER && (walkOverValues.includes(outcome) || completionType === 'winnerdidnotstart') && outcome !== OutComeTypes.ABANDONED && outcome !== OutComeTypes.DOUBLEWALKOVER) {
                    return (
                        <span className="outcome-font" data-testid={scorePrefix && `${scorePrefix}.outcome`}>{titleCase(outcome) || 'Walkover'}</span>
                    );
                }
            }
        };

        const renderTeam = (player1, player2, winnerObject, isCardView, teamPrefix) => {
            const showDecimalsP1 = showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player1.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player1.id === playerId.toString());
            const showDecimalsP2 = player2 != null && (showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player2.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player2.id === playerId.toString()));
            return (
                <div className="team">
                    <div className="flex-column player-details-container">
                        <div className="player-details">
                            {!!getPlayerTeamProfileImage(player1.id) && (
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={'/img/utr-ball--teal.svg'}
                                    images={getPlayerTeamProfileImage(player1.id)}
                                    imageType={'thumbnail'}
                                    parentStylesClass={'image-container'}
                                />
                            )}
                            {!getPlayerTeamProfileImage(player1.id) && (
                                <div className="image-container">
                                    {player1.nationality && (
                                        <Img
                                            src={getFlagUrl(player1.nationality)}
                                            className="flag"
                                            alt={player1.nationality}
                                        />
                                    )}
                                </div>
                            )}
                            <a
                                href={`/profiles/${player1.id}`}
                                className={`player-name ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                data-testid={teamPrefix && `${teamPrefix}.player1-link`}
                            >
                                {titleCase(getPlayerName(player1.firstName, player1.lastName, !!isCardView))}
                            </a>
                        </div>
                        {player2 && (
                            <div className="player-details">
                                {!!getPlayerTeamProfileImage(player2.id) && (
                                    <BackgroundImage
                                        baseUrl={'/v1/club/'}
                                        defaultImage={'/img/utr-ball--teal.svg'}
                                        images={getPlayerTeamProfileImage(player2.id)}
                                        imageType={'thumbnail'}
                                        parentStylesClass={'image-container'}
                                    />
                                )}
                                {!getPlayerTeamProfileImage(player2.id) && (
                                    <span className="image-container">
                                        {player2.nationality && (
                                            <Img
                                                src={getFlagUrl(player2.nationality)}
                                                className="flag"
                                                alt={player2.nationality}
                                            />
                                        )}
                                    </span>
                                )}
                                <a
                                    href={`/profiles/${player2.id}`}
                                    className={`player-name ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                    data-testid={teamPrefix && `${teamPrefix}.player2-link`}
                                >
                                    {titleCase(getPlayerName(player2.firstName, player2.lastName, !!isCardView))}
                                </a>
                            </div>
                        )}
                    </div>
                    <div className="flex-column utr-container">
                        {showRatings && (
                            <div
                                className={`utr ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                title={getRatingTitle(player1, gameType)}
                                data-testid={teamPrefix && `${teamPrefix}.player1-utr`}
                            >
                                <Utr player={player1} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }} sportTypeId={sportTypeId} /> {getRatingTitle(player1, gameType)}
                            </div>
                        )}
                        {player2 && showRatings && (
                            <div
                                className={`utr ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                title={getRatingTitle(player2, gameType)}
                                data-testid={teamPrefix && `${teamPrefix}.player2-utr`}
                            >
                                <Utr player={player2} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP2 }} sportTypeId={sportTypeId} /> {getRatingTitle(player1, gameType)}
                            </div>
                        )}
                    </div>
                    <div className="flex-row scores-container">
                        {winnerObject ? getScores(score, playerTypes.WINNER, teamPrefix) : getScores(score, playerTypes.LOSER, teamPrefix)}
                    </div>
                    <div className="flex-column winner-display-conatiner">
                        {winnerObject && showMatchWinner(outcome, completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </div>
            );
        };

        return (
            <>
                { players
                    ? (
                        <>
                            <div className="utr-card dual-match-card">
                                <div className={`${forceCardView || (force && force.cardView) ? 'd-block' : 'd-block d-md-none'}`}>
                                    <div className="card-view">
                                        <div className="header">
                                            <div className="rank" data-testid={dataTestId && `${dataTestId}.mobile.rank`}>{index}</div>
                                            <div className="flex-1">
                                                {isHomeWinner(players.winner1) && (
                                                    <>
                                                        {renderTeam(players.loser1, players.loser2, false, true, dataTestId && `${dataTestId}.mobile.loser-team`)}
                                                        {gameType === 'doubles' && <div className="mb8" />}
                                                        {renderTeam(players.winner1, players.winner2, true, true, dataTestId && `${dataTestId}.mobile.winner-team`)}
                                                    </>
                                                )}
                                                {!isHomeWinner(players.winner1) && (
                                                    <>
                                                        {renderTeam(players.winner1, players.winner2, true, true, dataTestId && `${dataTestId}.mobile.winner-team`)}
                                                        {gameType === 'doubles' && <div className="mb8" />}
                                                        {renderTeam(players.loser1, players.loser2, false, true, dataTestId && `${dataTestId}.mobile.loser-team`)}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="footer">
                                            <div data-testid={dataTestId && `${dataTestId}.mobile.event-date`}>{eventDate}</div>
                                            <div data-testid={dataTestId && `${dataTestId}.mobile.team-name`}>{team2.name}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                                    <div className="list-view">
                                        <div className="content row">
                                            <div className="col-9">
                                                <div className="rank" data-testid={dataTestId && `${dataTestId}.desktop.rank`}>{index}</div>
                                                <div className="flex-1">
                                                    {isHomeWinner(players.winner1) && (
                                                        <>
                                                            {renderTeam(players.loser1, players.loser2, false, false, dataTestId && `${dataTestId}.desktop.loser-team`)}
                                                            {renderTeam(players.winner1, players.winner2, true, false, dataTestId && `${dataTestId}.desktop.winner-team`)}
                                                        </>
                                                    )}
                                                    {!isHomeWinner(players.winner1) && (
                                                        <>
                                                            {renderTeam(players.winner1, players.winner2, true, false, dataTestId && `${dataTestId}.desktop.winner-team`)}
                                                            {renderTeam(players.loser1, players.loser2, false, false, dataTestId && `${dataTestId}.desktop.loser-team`)}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-3 bl jcsb">
                                                <div className="flex-column date-round">
                                                    <div data-testid={dataTestId && `${dataTestId}.desktop.event-date`}>{eventDate}</div>
                                                    <div data-testid={dataTestId && `${dataTestId}.desktop.team-name`}>{team2.name}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                    : null}
                {isCollegeDualMatch && playerWithOutScore.length > 0 ? (
                    <>
                        <div className="utr-card dual-match-card">
                            <div className={`${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                                <div className="list-view">
                                    <div className="content row">
                                        <div className="col-9">
                                            <div className="rank" data-testid={dataTestId && `${dataTestId}.college-desktop.rank`}>{index}</div>
                                            <div className="flex-1">
                                                {playerWithOutScore[0] && renderTeam(playerWithOutScore[0], playerWithOutScore[1], false, false, dataTestId && `${dataTestId}.college-desktop.team1`)}
                                                {playerWithOutScore[2] && renderTeam(playerWithOutScore[2], playerWithOutScore[3], false, false, dataTestId && `${dataTestId}.college-desktop.team2`)}
                                            </div>
                                        </div>
                                        <div className="col-3 bl jcsb">
                                            <div className="flex-column date-round">
                                                <div data-testid={dataTestId && `${dataTestId}.college-desktop.event-date`}>{eventDate}</div>
                                                <div data-testid={dataTestId && `${dataTestId}.college-desktop.team-name`}>{team2.name}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}
            </>
        );
    }
}

DualMatchCard.defaultProps = {
    showVerified: true,
    'data-testid': null,
};

function mapDispatchToProps(dispatch) {
    return {
        setPlayerPostedMatch: (data) => dispatch(actions.setPlayerPostedMatch(data)),
        resendInvites: (resultId) => dispatch(actions.resendInvites(resultId)),
        deleteUserScore: (resultId) => dispatch(actions.deleteUserScore(resultId)),
        acceptOrRejectScore: (resultId, acceptOrReject) => dispatch(actions.acceptOrRejectScore(resultId, acceptOrReject)),
    };
}

export default withRouter(withAuth(connect(null, mapDispatchToProps)(DualMatchCard)));
